const LOCAL_STORAGE_KEYS = {
    USER_SITE_KEY: 'userSite',
    HIDDEN_FEATURES_KEY: 'enableHiddenFeatures'
};

export { LOCAL_STORAGE_KEYS };
